import { useLayoutEffect } from "react";

// Fix: quando un Dialog (Radix) è aperto, react-remove-scroll blocca gli eventi
// wheel/touchmove anche sui contenuti "portalati" (Select, Popover dei multi-select),
// impedendo di scorrere i dropdown con mouse o touch. Mentre il body è "scroll-locked"
// fermiamo la propagazione così il browser gestisce lo scroll nativo dentro il dropdown.
export function useScrollLockFix() {
  useLayoutEffect(() => {
    const handler = (e) => {
      if (document.body.hasAttribute("data-scroll-locked")) {
        e.stopImmediatePropagation();
      }
    };
    const types = ["wheel", "touchmove"];
    const options = { capture: true, passive: false };
    types.forEach((t) => window.addEventListener(t, handler, options));
    return () => types.forEach((t) => window.removeEventListener(t, handler, options));
  }, []);
}
